if(!customElements.get('custom-featured-blog-posts')){
    class CustomFeaturedBlogPosts extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.navigations = this.querySelectorAll('.featured-blog-posts__navigation');
            this.articles = this.querySelectorAll('.featured-blog-posts__articles');
            this.navigations.forEach(item => {
                item.addEventListener('click', this.switchBlog.bind(this));
                item.addEventListener("keydown", (event) => {
                    if(event.key === "Enter"){
                        this.switchBlog(event);
                    }
                })
            })

            this.prevBtns = this.querySelectorAll('.posts-navigation__prev');
            this.prevBtns.forEach(item => {
                item.addEventListener('click', this.toPrevPage.bind(this));
                item.addEventListener('keydown', (event) => {
                    if(event.key === 'Enter'){
                        this.toPrevPage(event);
                    }
                })
            });

            this.nextBtns = this.querySelectorAll('.posts-navigation__next');
            this.nextBtns.forEach(item => {
                item.addEventListener('click', this.toNextPage.bind(this));
                item.addEventListener('keydown', (event) => {
                    if(event.key === 'Enter'){
                        this.toNextPage(event);
                    }
                })
            });

            this.ellipsisBtn = this.querySelector('.featured-blog-posts__navigation-icon');
            this.ellipsisBtn.addEventListener('click', this.openBlogList.bind(this));
            this.ellipsisBtn.addEventListener('keydown', (event) => {
                if(event.key === 'Enter'){
                    this.openBlogList(event);
                }
            })

            this.blog = this.querySelector('.featured-blog-posts-blogs');

            this.navigationWrapper = this.querySelector('.featured-blog-posts__navigations');
            this.contentWrapper = this.querySelector('.featured-blog-posts__content');

            this.adjustMinHeight();

            this.lastWidth = window.innerWidth;
            window.addEventListener('resize', () => {
                const currentWidth = window.innerWidth;

                if(currentWidth !== this.lastWidth){
                    this.adjustMinHeight();
                }
                
            }, false);
        }

        adjustMinHeight(){
            if(window.innerWidth > 1200){
                this.navigationWrapper.style.minHeight = 'unset';
                this.contentWrapper.style.minHeight = 'unset';

                return;
            }

            let contents = this.contentWrapper.querySelectorAll('.featured-blog-posts__article-content');
            let bgImages = this.querySelectorAll('.featured-blog-posts__article-image');

            let minHeight = 0;
            contents.forEach(item => {
                item.closest('.featured-blog-posts__articles').classList.add('d-block');
                let itemHeight = item.offsetHeight;
                item.closest('.featured-blog-posts__articles').classList.remove('d-block');
                if(itemHeight > minHeight){
                    minHeight = itemHeight;
                }
            })

            if(bgImages.length > 0){
                minHeight += bgImages[0].offsetHeight;
            }

            this.navigationWrapper.style.minHeight = `${minHeight}px`;
            this.contentWrapper.style.minHeight = `${minHeight}px`;
        }

        switchBlog(e){
            const currentBlog = e.currentTarget;
            const currentBlogIdx = currentBlog.dataset.idx;

            this.navigations.forEach(item => {
                item.classList.remove('active');
            })
            currentBlog.classList.add('active');

            this.articles.forEach(item => {
                var articleIdx = item.dataset.idx;

                if(articleIdx ===  currentBlogIdx){
                    item.setAttribute('data-active', 'true');
                }else{
                    item.setAttribute('data-active', 'false');

                    // reset index
                    item.querySelectorAll('.featured-blog-posts__article-content').forEach(i => {
                        if(i.dataset.articleIdx === '1'){
                            i.setAttribute('data-initial-article', 'true');
                        }else{
                            i.setAttribute('data-initial-article', 'false');
                        }
                    })
                }
            })

            this.closeBlogList();
            this.updateActiveIndex(currentBlogIdx);
        }

        openBlogList(){
            this.blog.setAttribute('aria-hidden', 'false');

            this.navigations.forEach(item => {
                item.classList.remove('active');
            })
        }

        closeBlogList(){
            this.blog.setAttribute('aria-hidden', 'true');
        }

        toPrevPage(e){
            var currentArticle = e.currentTarget.closest('.featured-blog-posts__article-content');
            var currentArticleWrapper = currentArticle.closest('.featured-blog-posts__article-content-wrapper');
            var currentArticleIdx = parseInt(currentArticle.dataset.articleIdx);
            var nextArticleIdx = currentArticleIdx - 1;
            var currentArticles = currentArticle.closest('.featured-blog-posts__articles');
            var currentArticleImageWrapper = currentArticles.querySelector('.featured-blog-posts__article-image-wrapper');

            currentArticleWrapper.querySelectorAll('.featured-blog-posts__article-content').forEach(item => {
                var itemIdx = parseInt(item.dataset.articleIdx);

                if(itemIdx === nextArticleIdx){
                    item.setAttribute('data-initial-article', 'true');
                }else{
                    item.setAttribute('data-initial-article', 'false');
                }
            })

            currentArticleImageWrapper.querySelectorAll('.featured-blog-posts__article-image').forEach(item => {
                var itemIdx = parseInt(item.dataset.articleIdx);

                if(itemIdx === nextArticleIdx){
                    item.setAttribute('data-initial-article', 'true');
                }else{
                    item.setAttribute('data-initial-article', 'false');
                }
            })
        }

        toNextPage(e){
            var currentArticle = e.currentTarget.closest('.featured-blog-posts__article-content');
            var currentArticleWrapper = currentArticle.closest('.featured-blog-posts__article-content-wrapper');
            var currentArticleIdx = parseInt(currentArticle.dataset.articleIdx);
            var nextArticleIdx = currentArticleIdx + 1;
            var currentArticles = currentArticle.closest('.featured-blog-posts__articles');
            var currentArticleImageWrapper = currentArticles.querySelector('.featured-blog-posts__article-image-wrapper');

            currentArticleWrapper.querySelectorAll('.featured-blog-posts__article-content').forEach(item => {
                var itemIdx = parseInt(item.dataset.articleIdx);

                if(itemIdx === nextArticleIdx){
                    item.setAttribute('data-initial-article', 'true');
                }else{
                    item.setAttribute('data-initial-article', 'false');
                }
            })

            currentArticleImageWrapper.querySelectorAll('.featured-blog-posts__article-image').forEach(item => {
                var itemIdx = parseInt(item.dataset.articleIdx);

                if(itemIdx === nextArticleIdx){
                    item.setAttribute('data-initial-article', 'true');
                }else{
                    item.setAttribute('data-initial-article', 'false');
                }
            })
        }

        updateActiveIndex(idx){
            this.setAttribute('data-active-idx', idx);
        }

        refresh(){
            this.init();
        }
    }

    customElements.define('custom-featured-blog-posts', CustomFeaturedBlogPosts);
}
